import React from 'react'

import { Card360 } from './Card360'
import { FinalCta, LandingFooter } from './Closing'
import { CoreLoop, Discovery, Pricing } from './Discovery'
import { Hero, Marquee } from './Hero'
import { Academies, Fights, Trainings } from './Progress'
import { Interlude, Manifesto, TeamsBanner } from './Story'
import { Support } from './Support'
import { MediaSection, Trailer } from './Trailer'
import s from './landing.module.css'
import { usePersona } from './persona'

/**
 * Landing page de marketing do Goodfellas (handoff "Site Goodfellas").
 * Página estática; estado mínimo: persona por idioma e play do trailer.
 */
export default function Landing({
  showMarquee = true,
}: {
  showMarquee?: boolean
}) {
  const persona = usePersona()

  return (
    <div className={s.page}>
      <Hero persona={persona} />
      {showMarquee && <Marquee />}
      <Trailer />
      <MediaSection />
      <Interlude />
      <TeamsBanner />
      <Discovery />
      <CoreLoop />
      <Pricing />
      <Card360 persona={persona} />
      <Fights />
      <Trainings />
      <Academies />
      <Manifesto />
      <Support />
      <FinalCta />
      <LandingFooter />
    </div>
  )
}
